import { render, staticRenderFns } from "./DefaultTranscript.vue?vue&type=template&id=6af204e0&"
import script from "./DefaultTranscript.vue?vue&type=script&lang=js&"
export * from "./DefaultTranscript.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTranscript.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports